export * from "./pett";

import { PayloadExerciseInfo } from "@tt-app/models/exercise";

export const API_ENDPOINTS = {
  ASSIGNMENT: {
    ACTIVE_LIST: "lingos-assignments/assignments/active/",
    BY_YEAR: "lingos-assignments/assignments/years/",
    DETAILS: "lingos-assignments/assignments",
    LIST: "lingos-assignments/assignments/",
    MINE: "lingos-assignments/assignments/mine"
  },
  CONTENT: {
    BOOKMARK: "lingos-contents/courses",
    BOOKMARKS: "lingos-contents/courses/bookmarked/",
    COURSE: "lingos-contents/courses",
    ORGANIZATION_COURSES: "lingos-contents/courses/orgs/",
    RECOMMENDED_COURSES: "lingos-contents/courses/orgs/recommended/"
  },
  EXERCISE: {
    // Fetch an exercise
    FETCH: ({ courseUuid, exerciseUuid, exerciseType }: PayloadExerciseInfo) =>
      `lingos-exercises/exercises/${courseUuid}/${exerciseType}/${exerciseUuid}/`,
    // Start an exercise
    START: ({ courseUuid, exerciseUuid, exerciseType }: PayloadExerciseInfo) =>
      `lingos-exercises/exercises/${courseUuid}/${exerciseType}/${exerciseUuid}/start/`,
    // Start an exercise
    START_EXERCISE_PRACTICE: ({ courseUuid, exerciseUuid, exerciseType }: PayloadExerciseInfo) =>
      `lingos-exercises/exercises/${courseUuid}/${exerciseType}/${exerciseUuid}/start/practice-mode/`,
    // Submit an user answer
    SUBMIT_ANSWER: ({ courseUuid, exerciseUuid, exerciseType }: PayloadExerciseInfo) =>
      `lingos-exercises/exercises/${courseUuid}/${exerciseType}/${exerciseUuid}/log/`,
    // End an exercise
    END: ({ courseUuid, exerciseUuid, exerciseType }: PayloadExerciseInfo) =>
      `lingos-exercises/exercises/${courseUuid}/${exerciseType}/${exerciseUuid}/end/`
  },
  LEARNING_HISTORY: {
    ACHIEVEMENT: "lingos-history/achievement/",
    ACTIVITY_SUMMARY: "lingos-history/activity-summary/",
    EXERCISE_LOGS: "lingos-history/exercise-logs",
    FEEDBACK: "lingos-history/user-feedback/",
    LEARNING_STATS: "lingos-history/learning-stats/",
    PERFORMANCE_SUMMARY: "lingos-history/performance-summary",
    RECENT_EXERCISES: "lingos-history/recent-exercises/"
  },
  TERRATALK_LIVE: {
    LIMITED_MODE: "terratalk-live/api/session/",
    STATE: "terratalk-live/api/state/",
    SESSION: "terratalk-live/api/sessions/"
  },
  USER: {
    ALIASES: "lingos-users/aliases/",
    COURSE_HISTORY: "lingos-history/courses",
    GROUPS: "lingos-users/orgs/groups/",
    INDIVIDUAL: "lingos-users/auth/",
    ORGANIZATION: "lingos-users/auth/",
    PROFILE: "lingos-users/profile/",
    PWD_CHNG_REQUEST: "lingos-users/reset-password/request/",
    PWD_CHNG_RESET: "lingos-users/reset-password/",
    SET_PASSWORD_WITH_TMP_PASSWORD: "lingos-users/set-password-with-tmp-password/",
    SET_PASSWORD_WITH_JWT: "lingos-users/orgs/set-password/jwt-token/",
    TAG_ALIAS: "lingos-users/tag-alias/",
    VALIDATE_TMP_PASSWORD: "lingos-users/validate-tmp-password/",
    VALIDATE_JWT: "lingos-users/orgs/auth/jwt-token/",
    VALIDATE_RESET_PASSWORD_JWT: "lingos-users/reset-password/validate-jwt-token/",
    VALIDATE_SSO: "lingos-users/sso/validate-jwt-token/"
  },
  RELEASE_NOTES: {
    LIST: "materials/api/releasenotes/"
  }
};
